import { FlexSpacer as uuiFlexSpacer } from '@epam/uui-components';

export const FlexSpacer = uuiFlexSpacer;